import VCFundPortfolioCompanyRequestDetail from "./VCFundPortfolioCompanyRequestDetail";

export default VCFundPortfolioCompanyRequestDetail;
